import React from "react";
import PropTypes from "prop-types";

/**
 * TableShimmer component for displaying loading state in tables
 * @param {Object} props Component props
 * @param {number} props.rows Number of shimmer rows to display
 * @param {number} props.columns Number of columns in each row
 * @returns {JSX.Element} TableShimmer component
 */
const TableShimmer = ({ rows = 10, columns = 5 }) => {
  return (
    <tbody>
      {Array(rows)
        .fill()
        .map((_, rowIndex) => (
          <tr key={`shimmer-row-${rowIndex}`}>
            {Array(columns)
              .fill()
              .map((_, colIndex) => (
                <td key={`shimmer-cell-${rowIndex}-${colIndex}`}>
                  <div className="shimmer-effect" style={{ height: "20px", width: "100%" }} />
                </td>
              ))}
          </tr>
        ))}
    </tbody>
  );
};

TableShimmer.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
};

export default TableShimmer;
